/**
 * Web auth — Discord OAuth session DTOs.
 */
import { z } from "zod";
export const AuthUserSchema = z.object({
    id: z.string(),
    username: z.string(),
    globalName: z.string().nullable().optional(),
    avatar: z.string().nullable().optional(),
});
export const AuthMeResponseSchema = z.object({
    authenticated: z.boolean(),
    authRequired: z.boolean(),
    user: AuthUserSchema.nullable().optional(),
});
export const DeviceTokenResponseSchema = z.object({
    token: z.string().min(1),
    tokenType: z.literal("Bearer"),
    expiresInSec: z.number().int().positive(),
});
//# sourceMappingURL=auth.js.map